export const CompetencyStatus = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
} as const;

export type CompetencyStatus = (typeof CompetencyStatus)[keyof typeof CompetencyStatus];
